import { render, staticRenderFns } from "./MarketingCostsTabs.vue?vue&type=template&id=2ed29833&scoped=true"
import script from "./MarketingCostsTabs.vue?vue&type=script&lang=js"
export * from "./MarketingCostsTabs.vue?vue&type=script&lang=js"
import style0 from "./MarketingCostsTabs.vue?vue&type=style&index=0&id=2ed29833&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed29833",
  null
  
)

export default component.exports